import { render, staticRenderFns } from "./LectureListPage.vue?vue&type=template&id=b1353b24"
import script from "./LectureListPage.vue?vue&type=script&lang=js"
export * from "./LectureListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports